import { ENDPOINT_UNSPLASH_SEARCH } from '../config/endpoints'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface UnsplashPhoto {
  id: string
  urls: {
    raw: string
    full: string
    regular: string
    small: string
    thumb: string
  }
  user: {
    name: string
    links: {
      html: string
    }
  }
  links: {
    download_location: string
  }
  width: number
  height: number
  alt_description: string | null
}

export interface UnsplashSearchResponse {
  total: number
  total_pages: number
  results: Array<UnsplashPhoto>
}

export const searchPhotos = async (
  query: string,
  page = 1,
  perPage = 20,
): Promise<UnsplashSearchResponse> => {
  const response = await AuthAxios.get<UnsplashSearchResponse>(
    ENDPOINT_UNSPLASH_SEARCH,
    {
      params: { query, page, perPage },
    },
  )
  return response.data
}
